import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminStoriesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('story');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
